import { Stack } from '@mui/material';
import { getGeneralOptions } from 'API/generalOptions/generalOptions';
import { getPersonalDetails } from 'API/personalDetails';
import { CustomMetaTitle } from 'Components/CustomMetaTitle';
import { LinkReturnToMain } from 'Components/LinkReturnToMain';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useDispatchApp, useIsDesktop } from 'Hooks';
import { useCallback, useEffect } from 'react';
import { setGeneralOptions } from 'Store';
import { setPersonalDetails } from 'Store/PersonalDetailsSlice';
import { AccordionsPersonalDetails } from './AccordionsPersonalDetails';
import { Title } from './Title';
import { useLoader } from 'Hooks/useLoader';

export const PersonalDetails = () => {
  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );
  const { isLoading, setIsLoading, loader } = useLoader();
  const dispatch = useDispatchApp();
  const isDesktop = useIsDesktop();

  const personalDetails = useAppSelector(
    ({ personalDetails: { personalDetails } }) => personalDetails
  );

  const initPersonalDetails = useCallback(async () => {
    setIsLoading(true);
    const [result, generalOptions] = await Promise.all([
      getPersonalDetails(),
      getGeneralOptions(),
    ]);
    dispatch(setPersonalDetails(result ?? null));
    dispatch(setGeneralOptions(generalOptions ?? null));
    setIsLoading(false);
  }, [dispatch, setIsLoading]);

  useEffect(() => {
    initPersonalDetails();
  }, [imposterId, initPersonalDetails]);

  return (
    <Stack gap={isDesktop ? '52px' : '24px'}>
      <CustomMetaTitle title={Dictionary[DICTIONARY.PersonalDetails].title} />
      <LinkReturnToMain />
      <Stack maxWidth={isDesktop ? '960px' : 'initial'} gap={'40px'}>
        <Title />
        {isLoading ? (
          loader
        ) : (
          <Stack gap={'24px'}>
            <AccordionsPersonalDetails personalDetails={personalDetails} />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
